import React from "react";

import { ChevronIcon } from "./Icons";

const AUTOPLAY_MS = 7000;

//Quote slideshow with arrows and dots, as on Wix. Moves on by itself, but pauses while the visitor hovers or tabs into it,
//and never for visitors who prefer reduced motion
const Testimonials = ({ title, items, label = "Testimonials" }) => {
  const [index, setIndex] = React.useState(0);
  const [isPaused, setIsPaused] = React.useState(false);
  const reducedMotion = React.useMemo(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches, []);
  const count = items.length;

  const go = (i) => setIndex((i + count) % count);

  React.useEffect(() => {
    if (isPaused || reducedMotion || count < 2) {
      return undefined;
    }
    const timer = window.setTimeout(() => setIndex((i) => (i + 1) % count), AUTOPLAY_MS);
    return () => window.clearTimeout(timer);
  }, [index, isPaused, reducedMotion, count]);

  return (
    <section
      className={"testimonials"}
      aria-label={title ? undefined : label}
      aria-labelledby={title ? "testimonials-title" : undefined}
    >
      {title ? (
        <h2
          id={"testimonials-title"}
          className={"heading is-display"}
        >
          {title}
        </h2>
      ) : null}

      <div
        className={"testimonials-slider"}
        aria-roledescription={"carousel"}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        onFocus={() => setIsPaused(true)}
        onBlur={() => setIsPaused(false)}
      >
        <button
          type={"button"}
          className={"testimonials-arrow is-prev"}
          aria-label={"Previous"}
          onClick={() => go(index - 1)}
        >
          <ChevronIcon direction={"left"} />
        </button>

        <div
          className={"testimonials-viewport"}
          aria-live={isPaused || reducedMotion ? "polite" : "off"}
        >
          {items.map((item, i) => (
            <figure
              key={item.quote}
              className={`testimonial ${i === index ? "is-active" : ""}`}
              aria-hidden={i !== index}
              aria-roledescription={"slide"}
              aria-label={`${i + 1} of ${count}`}
            >
              <blockquote className={"testimonial-quote"}>“{item.quote}”</blockquote>
              {item.author ? <figcaption className={"testimonial-author"}>- {item.author}</figcaption> : null}
            </figure>
          ))}
        </div>

        <button
          type={"button"}
          className={"testimonials-arrow is-next"}
          aria-label={"Next"}
          onClick={() => go(index + 1)}
        >
          <ChevronIcon />
        </button>
      </div>

      <div className={"testimonials-dots"}>
        {items.map((item, i) => (
          <button
            key={item.quote}
            type={"button"}
            className={`testimonials-dot ${i === index ? "is-active" : ""}`}
            aria-label={`Show review ${i + 1}`}
            aria-current={i === index ? "true" : undefined}
            onClick={() => go(i)}
          />
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
